var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h100-vh flex flex-column" }, [
    _c("div", { staticClass: "flex-auto" }, [
      _c("iframe", {
        staticStyle: { overflow: "auto" },
        attrs: {
          src: _vm.pdfUrl,
          frameborder: "0",
          width: "100%",
          height: "100%"
        }
      })
    ]),
    _c(
      "div",
      { staticClass: "text-right pad30-tb box-shadow pad20-r flex-shrink" },
      [
        _c(
          "el-button",
          {
            on: {
              click: function($event) {
                return _vm.$router.back()
              }
            }
          },
          [_vm._v("取 消")]
        ),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.confirm } },
          [_vm._v("确 定")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }